<template>
  <div class="w w1200">
    <div class="join-banner">
      <div class="bg"></div>
      <div class="join-us">
        <el-image class="icon" :src="require('@/assets/img/shop.png')"></el-image>
        <p class="desc">精选好货,服务保证,提供正品低价的购物选择,满足各种购物需求。</p>
        <el-button type="primary" @click="$router.push('/settleIn/merchantApply')">立即入驻</el-button>
      </div>
    </div>
    <div class="welcomeTabs">
      <el-tabs>
        <el-tab-pane :label="item.head" v-for="(item,index) in rulelists" :key="index">
          <p v-html="item.work"></p>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import headerComponent from "./head.vue";
import {redEnvelope, getMercharntStep, shopPass} from '@/api/xunyou'

export default {
  name: "merchantTypeSelect",
  data() {
    return {
      userInfo: this.$store.state.userInfo,
      rulelists: []
    };
  },
  mounted() {
    this.shopRules()
  },
  methods: {
    shopRules() {
      shopPass().then(res => {
        if (res.code == 0) {
          this.rulelists = res.rows
        }
      })
    },

    // 状态判断，不同的状态跳到相应的页面
    statusType(status, type) {
      switch (status) {
        case 1: //第一步，填资料 默认的
          return this.$router.push(`/merchantApply?type=${type}`)
          break;
        case 2: // 审核中
          return this.$router.push('/merchantStatus')
          break;
        case 3: // 资料审核通过，待付款
          return this.$router.push('/merchantpayFor')
          break;
        case 4: // 审核通过
          return this.$router.push('/storeOpen')
        default:
          return '--'
      }
    },
  }
};
</script>
<style scoped lang='less'>
.join-banner {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  height: 350px;
  background-color: #fff;
  margin: 20px 0;

  .join-us {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    background-color: #eaf3fa;

    .icon {
      width: 120px;
      height: 120px;
    }

    .desc {
      text-align: center;
      margin-top: 10px;
      margin-bottom: 20px;
    }

    /deep/ .el-button--primary {
      background-color: var(--main-theme-color);
      border-color: var(--main-theme-color);

      &:hover {
        background-color: #ed3535;
        border-color: #ed3535;
      }
    }
  }

  .bg {
    flex: 1;
    background: #ffffff url("../../assets/img/join.jpg") no-repeat center 0;
    background-size: contain;
  }
}

.welcomeTabs {
  padding: 15px;
  min-height: 300px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/merchantSettled/merchantTypeSelect.vue